import './App.css';
import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from './Components/Home';
import PlayNow from './Pages/PlayNow';
import PracticeBoard from './Pages/PracticeBoard';
import ScoreBoard from './Pages/ScoreBoard';
import ErrorMode from './Components/ErrorMode';
import SignUpGoogle from './Functions/SignUp/SignUpGoogle';
import Explore from './Pages//Explore';
import SurvivalMode from './Components/survivalmode';
import { ResultsProvider } from './Store/ResultsContext';
import TimeAttack from './Pages/TimeAttack';

function App() {
  return (
    <React.StrictMode>
      <ResultsProvider>
      <BrowserRouter>
        <Routes className='cursor'>
          <Route path="/" element={<Home/>} />
          <Route path="/playNow" element={<PlayNow />} />    
          <Route path="/explore" element={<Explore />} />    
          <Route path="/signupgoogle" element={<SignUpGoogle />} /> 
          <Route path="/TimeAttack" element={<TimeAttack />} /> 
          <Route path="/practiceboard" element={<PracticeBoard />} />  
          <Route path="/scoreboard" element={<ScoreBoard />} />  
          <Route path="/survivalmode" element={<SurvivalMode />} />    
          <Route path="/errormode" element={<ErrorMode />} />  
        </Routes>
      </BrowserRouter>
      </ResultsProvider>
    </React.StrictMode>
  );
}

export default App;

